
const redirectTo = url => new Promise(resolve => {
  window.addEventListener('onunload', () => resolve());
  window.location = url;
});

const redirectUtils = {
  redirectTo,
};
export default redirectUtils;